export const adminAccounts = {
  "admin.accounts.pageTitle": "Hesap Yönetimi",
  "admin.accounts.pageDescription": "Sistemdeki tüm kullanıcı hesaplarını yönetin ve görüntüleyin",
  "admin.accounts.title": "Hesap Yönetimi", 
  "admin.accounts.subtitle": "Kapsamlı filtreleme ve sıralama seçenekleriyle tüm kullanıcı hesaplarını görüntüleyin ve yönetin",
  "admin.accounts.errorTitle": "Hesaplar Yüklenirken Hata",
  "admin.accounts.errorMessage": "Hesap verileri yüklenemedi. Lütfen tekrar deneyin.",
  "admin.accounts.retryButton": "Tekrar Dene",

  "admin.accounts.filters.title": "Hesap Filtreleri",
  "admin.accounts.filters.accountInformationTitle": "Hesap Bilgileri",
  "admin.accounts.filters.dateRangeTitle": "Tarih Aralığı",
  "admin.accounts.filters.balanceRangeTitle": "Bakiye Aralığı",
  "admin.accounts.filters.accountNumber": "Hesap Numarası",
  "admin.accounts.filters.accountNumberPlaceholder": "Tam hesap numarasını girin",
  "admin.accounts.filters.username": "Kullanıcı Adı", 
  "admin.accounts.filters.usernamePlaceholder": "Tam kullanıcı adını girin",
  "admin.accounts.filters.accountStatus": "Hesap Durumu",
  "admin.accounts.filters.accountStatusPlaceholder": "Hesap durumu seçin",
  "admin.accounts.filters.allStatuses": "Tüm Durumlar",
  "admin.accounts.filters.dateFrom": "Hesap Açılış Başlangıç (yyyy-aa-gg)",
  "admin.accounts.filters.dateTo": "Hesap Açılış Bitiş (yyyy-aa-gg)",
  "admin.accounts.filters.accountShareType": "Hesap Payı Türü",
  "admin.accounts.filters.accountShareTypePlaceholder": "Pay türü seçin",
  "admin.accounts.filters.allShareTypes": "Tüm Pay Türleri",
  "admin.accounts.filters.programPercent": "Program Yüzdesi",
  "admin.accounts.filters.programPercentPlaceholder": "Program yüzdesi seçin",
  "admin.accounts.filters.allProgramPercents": "Tüm Program Yüzdeleri",
  "admin.accounts.filters.balanceMin": "Minimum Bakiye",
  "admin.accounts.filters.balanceMinPlaceholder": "Minimum bakiye girin",
  "admin.accounts.filters.balanceMax": "Maksimum Bakiye", 
  "admin.accounts.filters.balanceMaxPlaceholder": "Maksimum bakiye girin",
  "admin.accounts.filters.applyFilters": "Filtreleri Uygula",
  "admin.accounts.filters.clearFilters": "Filtreleri Temizle",

  "admin.accounts.table.title": "Kullanıcı Hesapları",
  "admin.accounts.table.showing": "Gösterilen",
  "admin.accounts.table.of": "/",
  "admin.accounts.table.accounts": "hesap",
  "admin.accounts.table.accountNumber": "Hesap Numarası",
  "admin.accounts.table.username": "Kullanıcı Adı",
  "admin.accounts.table.name": "Ad",
  "admin.accounts.table.status": "Durum",
  "admin.accounts.table.shareType": "Pay Türü",
  "admin.accounts.table.programPercent": "Program %",
  "admin.accounts.table.balance": "Bakiye", 
  "admin.accounts.table.creationDate": "Oluşturma Tarihi",
  "admin.accounts.table.lastUpdate": "Son Güncelleme",
  "admin.accounts.table.errorMessage": "Hesap verileri yüklenemedi",
  "admin.accounts.table.noDataMessage": "Mevcut filtrelere uygun hesap bulunamadı",

  "admin.accounts.table.status.active": "Aktif",
  "admin.accounts.table.status.inactive": "Pasif",

  "admin.accounts.profits.pageTitle": "Hesap Kâr Yönetimi",
  "admin.accounts.profits.pageDescription": "Kapsamlı filtreleme seçenekleriyle hesap kâr geçmişini görüntüleyin ve analiz edin",
  "admin.accounts.profits.title": "Hesap Kâr Yönetimi",
  "admin.accounts.profits.subtitle": "Gelişmiş filtreleme ve analizle hesap kâr geçmişinin kapsamlı görünümü",
  "admin.accounts.profits.errorTitle": "Kâr Verileri Yüklenirken Hata",
  "admin.accounts.profits.errorMessage": "Hesap kâr verileri yüklenemedi. Lütfen tekrar deneyin.",
  "admin.accounts.profits.retryButton": "Tekrar Dene",

  "admin.accounts.profits.filters.title": "Kâr Filtreleri",
  "admin.accounts.profits.filters.accountInformationTitle": "Hesap Bilgileri",
  "admin.accounts.profits.filters.periodTitle": "Dönem",
  "admin.accounts.profits.filters.profitsTitle": "Kârlar",
  "admin.accounts.profits.filters.accountNumber": "Hesap Numarası",
  "admin.accounts.profits.filters.accountNumberPlaceholder": "Tam hesap numarasını girin",
  "admin.accounts.profits.filters.username": "Kullanıcı Adı",
  "admin.accounts.profits.filters.usernamePlaceholder": "Tam kullanıcı adını girin",
  "admin.accounts.profits.filters.accountShare": "Hesap Payı",
  "admin.accounts.profits.filters.accountSharePlaceholder": "Hesap payı türü seçin",
  "admin.accounts.profits.filters.allAccountShares": "Tüm Pay Türleri",
  "admin.accounts.profits.filters.dateFrom": "Dönem Başlangıç (yyyy-aa-gg)",
  "admin.accounts.profits.filters.dateTo": "Dönem Bitiş (yyyy-aa-gg)",
  "admin.accounts.profits.filters.userProfitRange": "Kullanıcı Kâr Aralığı",
  "admin.accounts.profits.filters.userProfitMin": "Minimum Kullanıcı Kârı",
  "admin.accounts.profits.filters.userProfitMinPlaceholder": "Minimum kullanıcı kârı girin",
  "admin.accounts.profits.filters.userProfitMax": "Maksimum Kullanıcı Kârı",
  "admin.accounts.profits.filters.userProfitMaxPlaceholder": "Maksimum kullanıcı kârı girin",
  "admin.accounts.profits.filters.tradingProfitRange": "Trading Kâr Aralığı",
  "admin.accounts.profits.filters.tradingProfitMin": "Minimum Trading Kârı",
  "admin.accounts.profits.filters.tradingProfitMinPlaceholder": "Minimum trading kârı girin",
  "admin.accounts.profits.filters.tradingProfitMax": "Maksimum Trading Kârı",
  "admin.accounts.profits.filters.tradingProfitMaxPlaceholder": "Maksimum trading kârı girin",
  "admin.accounts.profits.filters.programProfitRange": "Program Kâr Aralığı",
  "admin.accounts.profits.filters.programProfitMin": "Minimum Program Kârı",
  "admin.accounts.profits.filters.programProfitMinPlaceholder": "Minimum program kârı girin",
  "admin.accounts.profits.filters.programProfitMax": "Maksimum Program Kârı",
  "admin.accounts.profits.filters.programProfitMaxPlaceholder": "Maksimum program kârı girin",
  "admin.accounts.profits.filters.applyFilters": "Filtreleri Uygula",
  "admin.accounts.profits.filters.clearFilters": "Filtreleri Temizle",

  "admin.accounts.profits.table.title": "Hesap Kâr Verileri",
  "admin.accounts.profits.table.showing": "Gösterilen",
  "admin.accounts.profits.table.of": "/",
  "admin.accounts.profits.table.records": "kayıt",
  "admin.accounts.profits.table.accountNumber": "Hesap Numarası",
  "admin.accounts.profits.table.username": "Kullanıcı Adı",
  "admin.accounts.profits.table.name": "Ad",
  "admin.accounts.profits.table.shareType": "Pay Türü",
  "admin.accounts.profits.table.period": "Dönem",
  "admin.accounts.profits.table.userProfit": "Kullanıcı Kârı",
  "admin.accounts.profits.table.tradingProfit": "Trading Kârı",
  "admin.accounts.profits.table.programProfit": "Program Kârı",
  "admin.accounts.profits.table.errorMessage": "Kâr verileri yüklenemedi",
  "admin.accounts.profits.table.noDataMessage": "Mevcut filtrelere uygun kâr kaydı bulunamadı",

  "admin.accounts.profitsTotals.title": "Hesap Kâr Toplamları Yönetimi",
  "admin.accounts.profitsTotals.subtitle": "Kapsamlı filtreleme seçenekleriyle toplam hesap kârlarını görüntüleyin ve analiz edin",
  "admin.accounts.profitsTotals.errorTitle": "Kâr Toplamları Verileri Yüklenirken Hata",
  "admin.accounts.profitsTotals.errorMessage": "Hesap kâr toplamları verileri yüklenemedi. Lütfen tekrar deneyin.",
  "admin.accounts.profitsTotals.retryButton": "Tekrar Dene",

  "admin.accounts.profitsTotals.filters.title": "Kâr Toplamları Filtreleri",
  "admin.accounts.profitsTotals.filters.accountInformationTitle": "Hesap Bilgileri",
  "admin.accounts.profitsTotals.filters.profitsTitle": "Kârlar",
  "admin.accounts.profitsTotals.filters.accountNumber": "Hesap Numarası",
  "admin.accounts.profitsTotals.filters.accountNumberPlaceholder": "Tam hesap numarasını girin",
  "admin.accounts.profitsTotals.filters.username": "Kullanıcı Adı",
  "admin.accounts.profitsTotals.filters.usernamePlaceholder": "Tam kullanıcı adını girin",
  "admin.accounts.profitsTotals.filters.accountShare": "Hesap Payı",
  "admin.accounts.profitsTotals.filters.accountSharePlaceholder": "Hesap payı türü seçin",
  "admin.accounts.profitsTotals.filters.allAccountShares": "Tüm Pay Türleri",
  "admin.accounts.profitsTotals.filters.userProfitRange": "Kullanıcı Kâr Aralığı",
  "admin.accounts.profitsTotals.filters.userProfitMin": "Minimum Kullanıcı Kârı",
  "admin.accounts.profitsTotals.filters.userProfitMinPlaceholder": "Minimum kullanıcı kârı girin",
  "admin.accounts.profitsTotals.filters.userProfitMax": "Maksimum Kullanıcı Kârı",
  "admin.accounts.profitsTotals.filters.userProfitMaxPlaceholder": "Maksimum kullanıcı kârı girin",
  "admin.accounts.profitsTotals.filters.tradingProfitRange": "Trading Kâr Aralığı",
  "admin.accounts.profitsTotals.filters.tradingProfitMin": "Minimum Trading Kârı",
  "admin.accounts.profitsTotals.filters.tradingProfitMinPlaceholder": "Minimum trading kârı girin",
  "admin.accounts.profitsTotals.filters.tradingProfitMax": "Maksimum Trading Kârı",
  "admin.accounts.profitsTotals.filters.tradingProfitMaxPlaceholder": "Maksimum trading kârı girin",
  "admin.accounts.profitsTotals.filters.programProfitRange": "Program Kâr Aralığı",
  "admin.accounts.profitsTotals.filters.programProfitMin": "Minimum Program Kârı",
  "admin.accounts.profitsTotals.filters.programProfitMinPlaceholder": "Minimum program kârı girin",
  "admin.accounts.profitsTotals.filters.programProfitMax": "Maksimum Program Kârı",
  "admin.accounts.profitsTotals.filters.programProfitMaxPlaceholder": "Maksimum program kârı girin",
  "admin.accounts.profitsTotals.filters.applyFilters": "Filtreleri Uygula",
  "admin.accounts.profitsTotals.filters.clearFilters": "Filtreleri Temizle",

  "admin.accounts.profitsTotals.table.title": "Hesap Kâr Toplamları Verileri",
  "admin.accounts.profitsTotals.table.showing": "Gösterilen",
  "admin.accounts.profitsTotals.table.of": "/",
  "admin.accounts.profitsTotals.table.records": "kayıt",
  "admin.accounts.profitsTotals.table.accountNumber": "Hesap Numarası",
  "admin.accounts.profitsTotals.table.username": "Kullanıcı Adı",
  "admin.accounts.profitsTotals.table.name": "Ad",
  "admin.accounts.profitsTotals.table.shareType": "Pay Türü",
  "admin.accounts.profitsTotals.table.userProfit": "Kullanıcı Kârı",
  "admin.accounts.profitsTotals.table.tradingProfit": "Trading Kârı",
  "admin.accounts.profitsTotals.table.programProfit": "Program Kârı",
  "admin.accounts.profitsTotals.table.errorMessage": "Kâr toplamları verileri yüklenemedi",
  "admin.accounts.profitsTotals.table.noDataMessage": "Mevcut filtrelere uygun kâr toplamı kaydı bulunamadı",

  "admin.accounts.profitsRegistration.title": "Trading Kârlarını Kaydet",
  "admin.accounts.profitsRegistration.subtitle": "Sistemdeki tüm broker hesapları için aylık trading kârlarını kaydedin",
  "admin.accounts.profitsRegistration.registerSection.title": "Trading Kârlarını Kaydet",
  "admin.accounts.profitsRegistration.registerSection.monthLabel": "Ay",
  "admin.accounts.profitsRegistration.registerSection.monthDescription": "Ay formatı \"yyyy-aa-01\"dır, önceki ayın kârları cari ayın ilk günü kaydedilir.",
  "admin.accounts.profitsRegistration.registerSection.monthPlaceholder": "yyyy-aa-01",
  "admin.accounts.profitsRegistration.registerSection.registerButton": "Trading Kârlarını Kaydet",
  "admin.accounts.profitsRegistration.resultSection.title": "Sonuç",
  "admin.accounts.profitsRegistration.resultSection.operationResult": "İşlem Sonucu",
  "admin.accounts.profitsRegistration.resultSection.success": "Başarılı",
  "admin.accounts.profitsRegistration.resultSection.fail": "Başarısız",
  "admin.accounts.profitsRegistration.resultSection.numBrokerAccounts": "Broker hesap sayısı",
  "admin.accounts.profitsRegistration.resultSection.numRegisteredAccounts": "Kayıtlı hesap sayısı",
  "admin.accounts.profitsRegistration.resultSection.accountsNotRegistered": "Kaydedilmemiş hesaplar",
  "admin.accounts.profitsRegistration.resultSection.accountsAlreadyRegistered": "Kârları zaten kaydedilmiş hesaplar",
  "admin.accounts.profitsRegistration.resultSection.totalProfit": "Toplam Kâr",
  
  "admin.accounts.profitsRegistration.validation.invalidFormat": "Ay yyyy-aa-01 formatında olmalıdır",
  "admin.accounts.profitsRegistration.validation.invalidDate": "Geçersiz tarih",
  "admin.accounts.profitsRegistration.validation.invalidMonth": "Ay 01 ile 12 arasında olmalıdır",
  "admin.accounts.profitsRegistration.validation.futureMonth": "Gelecek aylar için kâr kaydedilemez",

  "admin.accounts.profitsRegistration.messages.success": "Kârlar Başarıyla Kaydedildi",
  "admin.accounts.profitsRegistration.messages.successDescription": "Hesap kârları başarıyla kaydedildi",
  "admin.accounts.profitsRegistration.messages.error": "Kayıt Hatası",
  "admin.accounts.profitsRegistration.messages.csrfError": "Güvenlik token\'ı oluşturulamadı",
  "admin.accounts.profitsRegistration.messages.authError": "Kimlik doğrulama gerekli",
  "admin.accounts.profitsRegistration.messages.serverError": "Sunucu hatası oluştu",
  "admin.accounts.profitsRegistration.messages.operationFailed": "Kâr kaydı başarısız oldu",
  "admin.accounts.profitsRegistration.messages.unexpectedError": "Beklenmeyen bir hata oluştu",

  "admin.accounts.balanceUpdate.title": "Hesap Bakiyelerini Güncelle",
  "admin.accounts.balanceUpdate.subtitle": "Broker sisteminden tüm trading hesaplarının mevcut bakiyesini güncelle",
  "admin.accounts.balanceUpdate.updateSection.title": "Hesap Bakiyelerini Güncelle",
  "admin.accounts.balanceUpdate.updateSection.updateButton": "Hesap Bakiyelerini Güncelle",
  "admin.accounts.balanceUpdate.resultSection.title": "Sonuç",
  "admin.accounts.balanceUpdate.resultSection.operationResult": "İşlem Sonucu",
  "admin.accounts.balanceUpdate.resultSection.success": "Başarılı",
  "admin.accounts.balanceUpdate.resultSection.fail": "Başarısız",
  "admin.accounts.balanceUpdate.resultSection.numBrokerAccounts": "Broker hesap sayısı",
  "admin.accounts.balanceUpdate.resultSection.numUpdatedAccounts": "Güncellenen hesap sayısı",
  "admin.accounts.balanceUpdate.resultSection.accountsNotRegistered": "Kaydedilmemiş hesaplar",
  "admin.accounts.balanceUpdate.resultSection.totalFunds": "Toplam Fonlar",

  "admin.accounts.balanceUpdate.messages.success": "Bakiyeler Başarıyla Güncellendi",
  "admin.accounts.balanceUpdate.messages.successDescription": "Hesap bakiyeleri başarıyla güncellendi",
  "admin.accounts.balanceUpdate.messages.error": "Güncelleme Hatası",
  "admin.accounts.balanceUpdate.messages.csrfError": "Güvenlik token\'ı oluşturulamadı",
  "admin.accounts.balanceUpdate.messages.authError": "Kimlik doğrulama gerekli",
  "admin.accounts.balanceUpdate.messages.serverError": "Sunucu hatası oluştu",
  "admin.accounts.balanceUpdate.messages.operationFailed": "Bakiye güncelleme başarısız oldu",
  "admin.accounts.balanceUpdate.messages.unexpectedError": "Beklenmeyen bir hata oluştu",

  "admin.accounts.autoRegister.title": "Otomatik Hesap Kaydı",
  "admin.accounts.autoRegister.subtitle": "Broker sisteminden kullanıcı trading hesaplarını otomatik olarak kaydedin",
  "admin.accounts.autoRegister.registerSection.title": "Hesapları Otomatik Kaydet",
  "admin.accounts.autoRegister.registerSection.registerButton": "Hesapları Otomatik Kaydet",
  "admin.accounts.autoRegister.resultSection.title": "Sonuç",
  "admin.accounts.autoRegister.resultSection.operationResult": "İşlem Sonucu",
  "admin.accounts.autoRegister.resultSection.success": "Başarılı",
  "admin.accounts.autoRegister.resultSection.fail": "Başarısız",
  "admin.accounts.autoRegister.resultSection.matchedUsers": "Eşleşen Hesaplar",
  "admin.accounts.autoRegister.resultSection.unmatchedUsers": "Eşleşmeyen Hesaplar",
  "admin.accounts.autoRegister.resultSection.usersWithoutAccounts": "Hesapsız Kullanıcılar",
  "admin.accounts.autoRegister.resultSection.ignoredOfferName": "Yok Sayılan Teklif Adı",
  "admin.accounts.autoRegister.resultSection.ignoredIds": "Yok Sayılan Kimlikler",
  "admin.accounts.autoRegister.messages.success": "Otomatik Kayıt Başarıyla Tamamlandı",
  "admin.accounts.autoRegister.messages.successDescription": "Hesaplar başarıyla kaydedildi",
  "admin.accounts.autoRegister.messages.error": "Otomatik Kayıt Hatası",
  "admin.accounts.autoRegister.messages.csrfError": "Güvenlik token\'ı oluşturulamadı",
  "admin.accounts.autoRegister.messages.authError": "Kimlik doğrulama gerekli",
  "admin.accounts.autoRegister.messages.serverError": "Sunucu hatası oluştu",
  "admin.accounts.autoRegister.messages.operationFailed": "Otomatik kayıt başarısız oldu",
  "admin.accounts.autoRegister.messages.unexpectedError": "Beklenmeyen bir hata oluştu",
};
